import type { AllRouteEndpoints } from "../routeTypes";

export const postEngagementLandingPagesAppGroupIdLandingPageBsonIdPostLaunchDraftCacheKeys: AllRouteEndpoints[] = [
  "/engagement/landing_page_data",
  "/engagement/landing_pages_data",
];

export const deleteEngagementLandingPagesAppGroupIdLandingPageBsonIdPostLaunchDraftCacheKeys: AllRouteEndpoints[] =
  ["/engagement/landing_page_data", "/engagement/landing_pages_data"];
